module.exports = __webpack_public_path__ + "img/slide_5.d99615c0.jpg";